import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import ButtonExit from "../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../components/UI/button/ButtonAdd";

export const IMPORT_SOURCE_DXF = "dxf";
export const IMPORT_SOURCE_3DS = "3ds";

const SOURCE_OPTIONS = [
    {
        value: IMPORT_SOURCE_DXF,
        label: "Загрузить деталь в формате dxf",
    },
    {
        value: IMPORT_SOURCE_3DS,
        label: "Загрузить ручку в формате 3ds",
    },
];

/**
 * Выбор типа загрузки: DXF-деталь или 3DS-ручка.
 * Стиль как у ModalSelectAction / NameModal.
 */
const ImportSourceDialog = ({
    open,
    onClose,
    onConfirm,
}) => {
    const [source, setSource] = useState(IMPORT_SOURCE_DXF);

    useEffect(() => {
        if (open) setSource(IMPORT_SOURCE_DXF);
    }, [open]);

    const handleClose = () => onClose?.();

    const handleConfirm = () => {
        onConfirm?.(source);
    };

    return (
        <Dialog
            open={Boolean(open)}
            onClose={handleClose}
            PaperProps={{
                style: {
                    minWidth: 400,
                    borderRadius: 8,
                },
            }}
        >
            <DialogTitle textAlign="center">
                Загрузить свою деталь
            </DialogTitle>
            <DialogContent sx={{pt: 1}}>
                <RadioGroup
                    name="module3d-import-source"
                    value={source}
                    onChange={(event) => setSource(event.target.value)}
                >
                    <Box sx={{display: "flex", flexDirection: "column"}}>
                        {SOURCE_OPTIONS.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio/>}
                                label={option.label}
                                sx={{
                                    margin: 0,
                                    height: "36px",
                                    "&:not(:last-of-type)": {
                                        marginBottom: "4px",
                                    },
                                    borderBottom: (theme) =>
                                        `${theme.palette.primary.stroke} solid 1px`,
                                    "&:hover": {
                                        backgroundColor: (theme) =>
                                            theme.palette.primary.light,
                                    },
                                }}
                            />
                        ))}
                    </Box>
                </RadioGroup>
            </DialogContent>
            <DialogActions sx={{px: "1.25rem", py: 1.5, gap: 1}}>
                <ButtonExit
                    text="Отменить"
                    onClick={handleClose}
                    width={96}
                    sx={{height: 40, fontSize: "14px"}}
                />
                <ButtonAdd
                    text="Далее"
                    onClick={handleConfirm}
                    width={96}
                    height={40}
                    fontSize="14px"
                />
            </DialogActions>
        </Dialog>
    );
};

export default ImportSourceDialog;
